import { required, maxLength } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.description.maxLength && errors.push('Descrição não pode conter mais de 30 caracteres.')
    return errors
  },
}
